$(function () {
    var timer, ignoreScroll = false;
    $('.toggler-button').on('click', function () {
        var $parent = $(this).closest('.faq-item');
        if ($parent.hasClass('open')) { $parent.toggleClass('open'); }
        else {
            $('.faq-item').removeClass('open')
            $parent.addClass('open');
        }
    });

    $('.cp-faq-sidebar li').on('click', function () {
        $('.cp-faq-sidebar li').removeClass('active');
        $(this).addClass('active');
    });

    $('.cp-faq-searchbar').on('keyup', function () {
        var val = $(this).val();
        if (!val || val === "") return $('.faq-item').show();
        $('.faq-item').each(function () {
            $(this).hide();
            var text = $(this).find('.toggler-button').text();
            if (text.toLowerCase().indexOf(val.toLowerCase()) >= 0) {
                $(this).show();
            }
        });
    });

    $('.cp-faq-sidebar li').on('click', function () {
        ignoreScroll = true;
        clearTimeout(timer);
        timer = setTimeout(function () {
            ignoreScroll = false;
        }, 1000);
        var section = $(this).data('section'),
            pos = $("#" + section).offset().top - 150;
        $('html,body').animate({
            scrollTop: pos
        }, 'slow');
    });


    if ($('.cp-faq-sidebar').length) {
        // Cache selectors
        var topMenu = $('.cp-faq-sidebar')
        topMenuHeight = topMenu.outerHeight() + 15,
            // All list items
            menuItems = topMenu.find("li"),
            // Anchors corresponding to menu items
            scrollItems = menuItems.map(function () {
                var item = $("#" + $(this).data("section"));
                if (item.length) { return item; }
            });

        $(window).scroll(function () {
            var win_width = $(window).width();
            if (win_width > 749) {

                if (!ignoreScroll) {
                    // Get container scroll position
                    var fromTop = $(this).scrollTop() + 151;

                    // Get id of current scroll item
                    var cur = scrollItems.map(function () {
                        if ($(this).offset().top < fromTop)
                            return this;
                    });

                    // Get the id of the current element
                    cur = cur[cur.length - 1];
                    var id = cur && cur.length ? cur[0].id : $(menuItems[0]).data('section');

                    // Set/remove active class
                    menuItems
                        .removeClass("active")
                        .filter("[data-section='" + id + "']").addClass("active");
                }

                // Float the navigation
                var topoffset = $('.cp-faq-sidebar').offset().top;

                var botoffset = $('.faq-box-banner').offset().top;

                var block_height = $('.ability-to-float').height();
                botoffset = botoffset - block_height - 250;
                topoffset = topoffset - 200;

                var sTop = $(window).scrollTop();

                var top_fix_to_abs = botoffset - topoffset;
                if (sTop < topoffset) {
                    $('.ability-to-float').removeClass('curr_fix');
                    $('.ability-to-float').css('top', "");
                }
                if (sTop > topoffset && sTop < botoffset) {
                    $('.ability-to-float').addClass('curr_fix');
                    $('.ability-to-float').css('top', sTop - topoffset + "px");
                }
                if (sTop >= botoffset && sTop > topoffset) {
                    $('.ability-to-float').removeClass('curr_fix');
                    $('.ability-to-float').css('top', top_fix_to_abs);
                    //return;
                }
            }
        });
    }
});